<template>
<div class="land-logistic">
	<grid>
		<grid-item size="1/1">
			<h3>Logistics by sea</h3>
		</grid-item>
	</grid>
	<div class="logistic-content">
		<grid>
			<grid-item size="1/2">
				<p>From</p>
				<custom-input
					type="text"
					placeholder="Alto Peru, Tacna, Peru"
					inputStyle="dark"
					v-model="from"
				/>
				<span class="nearby-button">Nearby ports</span>
			</grid-item>
			<grid-item size="1/2">
				<p>To</p>
				<custom-input
					type="text"
					placeholder="Port of Guayaquil - ECGYE"
					inputStyle="dark"
					v-model="to"
				/>
			</grid-item>
		</grid>
	</div>
</div>
</template>

<script>
import CustomInput from '@/components/secondary/CustomInput'

export default {
	components: {
		CustomInput
	},
	data: () => ({
		from: null,
		to: null
	})
}
</script>

<style lang="scss">
</style>
